import {Container} from './style.js';
function Cnpj() {
const currentYear = new Date().getFullYear();
  return (
    <Container>
        <h4>00.000.000/0001-00 Contavares Assessoria Contábil LTDA - Copyright © {currentYear}.</h4>
    </Container>
  );
}
export default Cnpj;